import Vue    		from 'vue'
import App    		from './App'
import router 		from './router'
import store  		from './store'
import AWS 			from 'aws-sdk/global'
import Toasted 		from 'vue-toasted'
import VueMoment 	from 'vue-moment'


Vue.config.productionTip = false
/* eslint-disable no-new */


AWS.config.region = 'us-east-1' // your region
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: 'us-east-1:596425f8-13e4-4897-9f52-1d563516fe07' // your identity pool id
})

window.trg = {}

new Vue({
	el: '[data-app]',
	store,
	router,
	components: { App },
	template: '<app />'
})

Vue.use(VueMoment)

Vue.use(Toasted, {
	containerClass: 'toast-container',
	iconPack: 'fontawesome',
})

Vue.filter('total', function (value) {
	if (!value) return ''
	return value.toFixed(2)
})


// WEBPACK FOOTER //
// ./src/main.js